import React from 'react';
import axios from 'axios';

import { FsButton } from '~/components/core/FsWrappers';
import Text from '~/components/core/TextComponents/Text';
import type { PhoneSurveyConfigurationModel } from '~/server_shared/openapi/data-contracts';
import { reportAxiosError } from '~/Utils';

import CardDialog from '../../../../CardDialog';
import EditPhoneSurveyConfigDialog from '../PhoneConfigurations/PhoneSurveyConfiguration/EditPhoneSurveyConfigDialog/EditPhoneSurveyConfigDialog';
import PhoneSurveyConfigurationView from '../PhoneConfigurations/PhoneSurveyConfiguration/PhoneSurveyConfigurationView/PhoneSurveyConfigurationView';

interface OrgPhoneSurveyCardProps {
  organizationId: number;
  surveyConfiguration: PhoneSurveyConfigurationModel;
  isLoading: boolean;
  isError: boolean;
  reloadSurveyConfiguration: () => Promise<unknown>;
}

const OrgPhoneSurveyCard: React.FC<OrgPhoneSurveyCardProps> = ({
  organizationId,
  surveyConfiguration,
  isLoading,
  isError,
  reloadSurveyConfiguration,
}) => {
  const [isEditOpen, setIsEditOpen] = React.useState(false);

  const handleSubmit = async (values: unknown): Promise<void> => {
    try {
      await axios.put(`/api/v1/organizations/${organizationId}/phone_survey_configuration`, values);
      await reloadSurveyConfiguration();
    } catch (error) {
      reportAxiosError(error);
      throw error;
    }
  };

  return (
    <div className="mt-32">
      <CardDialog
        title="Organization Phone Survey"
        width="md"
        action={
          <FsButton color="primary" onClick={() => setIsEditOpen(true)}>
            Edit survey
          </FsButton>
        }
      >
        <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.DISABLED}>
          Survey content is shared across all phone profiles. Enable per profile from the profile detail page.
        </Text>
        <div className="mt-12">
          <PhoneSurveyConfigurationView
            surveyConfiguration={surveyConfiguration}
            isLoading={isLoading}
            isError={isError}
          />
        </div>
      </CardDialog>
      {isEditOpen ? (
        <EditPhoneSurveyConfigDialog
          configuration={surveyConfiguration}
          onCancel={() => setIsEditOpen(false)}
          onSubmit={handleSubmit}
        />
      ) : null}
    </div>
  );
};

export default OrgPhoneSurveyCard;
